<template>
  <section class="section">
    <van-row class="section-head">
      <van-col span="22">
        <h2 class="title">{{ t(relatedSectionKey(titleKey)) }}</h2>
      </van-col>
      <van-col span="2">
        <van-icon name="arrow" size="16" color="#9ca3af" />
      </van-col>
    </van-row>

    <div class="scroll-list">
      <AppRow v-for="app in apps" :key="app.id" :app="app" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import type { RelatedApp } from '@/lib/app-data';
import { relatedSectionKey } from '../i18n-keys';
import AppRow from './AppRow.vue';

defineProps<{
  titleKey: string;
  apps: RelatedApp[];
}>();

const { t } = useI18n();
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.section-head {
  align-items: center;
  margin-bottom: 12px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.scroll-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scrollbar-width: none;
}

.scroll-list::-webkit-scrollbar {
  display: none;
}
</style>
